import axios from '../../services/httpService';
import { notificationMsg } from '../../utility/Notification';
import { API_URL } from '../../constants/ApiUrls';
import { getProjects } from './projects.actions';

export const createOnBoardRequest =
  (data, onOk, setFormData, role, setProjectCategory, archive, setHeading, setLoader, markAsChannel) => async (dispatch) => {
    try {
      const response = await axios.post('/projectOnBoarding/create', data);
      if (response.status === 201) {
        dispatch({
          type: 'CREATE_ONBOARDING_PROJECT_REQUEST',
          payload: response.data,
        });
        setLoader(false);
        notificationMsg('success', 'Project onboarding request is completed successfully!');
        setProjectCategory('');
        dispatch(getOnBoardingProjects(archive, setHeading, markAsChannel));
        onOk?.();
        setFormData(null);
      }
    } catch (error) {
      setLoader(false);
      notificationMsg('error', error?.response?.data?.error);
    }
  };

export const getOnBoardingProjects = (archive, setHeading, markAsChannel) => async (dispatch) => {
  return new Promise(async (res, rej) => {
    const config = {
      method: 'get',
      url: archive === false ? `projectOnBoarding/getProjectsByRole` : `projectOnBoarding/getArchivedProjects`,
    };
    try {
      const response = await axios(config);
      res(true);
      if (response.data) {
        if (archive) {
          setHeading('Archived OnBoarding Requests');
          dispatch({
            type: 'GET_ARCHIVED_PROJECT',
            payload: response.data,
          });
        } else {
          if (markAsChannel && markAsChannel === true) {
            setHeading('Presale Channel Created Requests');
          } else {
            setHeading('OnBoarding Requests');
          }
        }
        dispatch({
          type: 'GET_ONBOARDING_PROJECT',
          payload: response.data,
        });
      }
    } catch (error) {
      console.log(error);
      res(true);
    }
  });
};
export const showLoading = (status) => {
  return {
    type: 'LOADING_ACTION',
    payload: status,
  };
};

export const updateOnBoardedProject = (id, data, onOk, setFormData, role, setProjectCategory, archive, setHeading) => async (dispatch) => {
  try {
    data['onBoardingId'] = id;
    const response = await axios.post(`projectOnBoarding/update`, data);
    dispatch({
      type: 'UPDATE_ONBOARDING_PROJECT',
      payload: response.data,
    });
    notificationMsg('success', 'Project is updated Successfully!');
    setProjectCategory('');
    dispatch(getOnBoardingProjects(archive, setHeading));
    onOk?.();
    setFormData(onBoardProjectDefaultData);
  } catch (error) {
    notificationMsg('error', error?.response?.data?.error);
  }
};

export const deleteOnBoardProject = (onBoardingId, setDelOnboardingModal, role) => async (dispatch) => {
  try {
    const data = { onBoardingId };
    const response = await axios.post(API_URL.DELETE_ONBOARDING_PROJECT, data);
    if (response) {
      setDelOnboardingModal(false);
      dispatch(getOnBoardingProjects());
      notificationMsg('Success', 'Project is deleted successfully.');
    }
  } catch (error) {
    notificationMsg('Error', error?.response?.data?.error);
  }
};

export const archiveOnBoardProject = (isArchived, onBoardingId, setDelOnboardingModal, role, setHeading, archivedReason) => async (dispatch) => {
  try {
    const data = { isArchived, onBoardingId, archivedReason };
    const response = await axios.put(API_URL.ARCHIVED_ONBOARDING_PROJECT, data);
    if (response) {
      setDelOnboardingModal(false);
      dispatch(getOnBoardingProjects(false, setHeading));
      notificationMsg('Success', 'Project is archived successfully.');
    }
  } catch (error) {
    notificationMsg('Error', error?.response?.data?.error);
  }
};
export const onBoardProject =
  (
    body,
    rowId,
    setConfirmationModal,
    myRole,
    archive,
    setHeading,
    selectedPmId,
    setProjectType,
    setRow,
    setPmValues,
    setSelectedBdResource,
    setLoader,
    setProceedAsPresale,
  ) =>
  async (dispatch) => {
    try {
      // console.log("Check body for create api in onboard: ", body)
      const response = await axios.post(`/project/create`, body);
      if (response.status === 201) {
        dispatch(
          acceptOnBoardProject(
            rowId,
            setConfirmationModal,
            myRole,
            archive,
            setHeading,
            selectedPmId,
            setProjectType,
            setRow,
            setPmValues,
            setSelectedBdResource,
            setLoader,
            setProceedAsPresale,
            response.data.project_id,
          ),
        );
      }
    } catch (error) {
      console.log('====>', error);
      setLoader(false);
      notificationMsg('error', error?.response?.data?.error);
    }
  };
export const acceptOnBoardProject =
  (
    onBoardingId,
    setConfirmationModal,
    role,
    archive,
    setHeading,
    pm,
    setProjectType,
    setRow,
    setPmValues,
    setSelectedBdResource,
    setLoader,
    setProceedAsPresale,
    projectId,
  ) =>
  async (dispatch) => {
    try {
      const data = { status: 'CLOSED', pmId: pm };
      const response = await axios.put(`/projectOnBoarding/updateStatus/${onBoardingId}/${projectId}`, data);
      if (response) {
        setProjectType('');
        setRow(null);
        setPmValues(null);
        setSelectedBdResource(null);
        setLoader(false);
        setConfirmationModal(false);
        dispatch(getOnBoardingProjects(archive, setHeading));
        if (response.data.quickBook) {
          notificationMsg('Success', 'The project and QuickBook customer were successfully onboarded.');
        } else {
          notificationMsg('Success', 'The project was successfully onboarded, but the QuickBook customer was not.');
        }
        setProceedAsPresale(false);
      }
    } catch (error) {
      setLoader(false);
      notificationMsg('Error', error?.response?.data?.error);
    }
  };

export const updateBillings = (body, setModal, setRow, setProjectBillingData, archive, setHeading) => async (dispatch) => {
  try {
    const data = { status: 'CLOSED' };
    const response = await axios.put(`/projectOnBoarding/updateBillingDetail`, body);
    if (response.status === 200) {
      setModal(false);
      setRow(null);
      setProjectBillingData(null);
      dispatch(getOnBoardingProjects(archive, setHeading));
      notificationMsg('Success', response.data?.message);
    }
  } catch (error) {
    notificationMsg('Error', error?.response?.data?.error);
  }
};

export const addProjectBillings = (body) => async (dispatch) => {
  try {
    const response = await axios.put(`/project/updateBillingDetailProjects`, body);
    if (response.status === 200) {
      // setProjectBillingData(null);
      // setConfirmationModal(false);
      // dispatch(getProjects());
      notificationMsg('Success', response.data?.message);
    }
  } catch (error) {
    notificationMsg('Error', error?.response?.data?.error);
  }
};

export const channelCreatedOnBoardProject = (isChannelCreated, onBoardingId, archive, setHeading) => async (dispatch) => {
  try {
    const data = { isChannelCreated, onBoardingId };
    const response = await axios.put(API_URL.CHANNEL_CREATED_ONBOARDING_PROJECT, data);
    if (response?.status === 200) {
      dispatch(getOnBoardingProjects(archive, setHeading));
      notificationMsg('Success', response?.data?.message);
    }
  } catch (error) {
    notificationMsg('Error', error?.response?.data?.error);
  }
};

export const getChannelCreatedProjects = (setHeading) => async (dispatch) => {
  return new Promise(async (res, rej) => {
    const config = {
      method: 'get',
      url: `projectOnBoarding/getAllChannelCreatedProjects`,
    };
    try {
      const response = await axios(config);
      res(true);
      if (response.data) {
        setHeading('Presale Channel Created Requests');
        dispatch({
          type: 'GET_CHANNEL_CREATED_PROJECT',
          payload: response.data,
        });
      }
    } catch (error) {
      console.log(error);
      res(true);
    }
  });
};

export const setOnboardingSuccess = (data) => ({
  type: 'ONBOARDING_SUCCESS',
  payload: data,
});
